module.exports = ".stream {\n  /**\n   * Lay out the children of this container with\n   * flexbox.\n   */\n  display: flex;\n\n  /*\n   * Set the main axis to be vertical, but present\n   * the children in reverse order of that in which\n   * they occur in the DOM.\n   */\n  flex-direction: column-reverse;\n}\n\n.post + .post {\n  margin-bottom: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!/Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/flexbox-patterns/src/styles/stream.css
// module id = 786
// module chunks = 0